(() => {
  if (window.__msMenuPreviewBootstrapped) return;
  window.__msMenuPreviewBootstrapped = true;
  const repairMenuImage = image => {
    if (!(image instanceof HTMLImageElement) || !image.closest('.ms-nav, .ms-mobile')) return;
    const backup = image.dataset.msFallbackSrc;
    if (backup && !image.dataset.msFallbackTried) {
      image.dataset.msFallbackTried = 'true';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = backup;
      return;
    }
    image.classList.add('ms-menu-image--missing');
    const tile = image.closest('.ms-nav__feature, .ms-nav__brand-photo, .ms-nav__new-row a');
    if (tile) {
      if (!tile.dataset.msPlaceholderLabel) tile.dataset.msPlaceholderLabel = image.alt || 'Featured';
      tile.classList.add('ms-menu-image-container--missing');
    }
  };
  document.addEventListener('error', event => repairMenuImage(event.target), true);
  function initMenus(root = document) {
    root.querySelectorAll('.ms-nav img, .ms-mobile img').forEach(image => {
      if (image.complete && image.naturalWidth === 0) repairMenuImage(image);
    });
    root.querySelectorAll('[data-ms-menu]:not([data-ms-ready])').forEach(desktop => {
      desktop.dataset.msReady = 'true';
      const tabs = [...desktop.querySelectorAll('[data-ms-tab]')];
      const panels = [...desktop.querySelectorAll('[data-ms-panel]')];
      let active = null;
      let hoverTimer;
      const hiding = new WeakMap();
      const fitPanel = panel => {
        panel.style.maxHeight = `${Math.max(240, Math.floor(window.innerHeight - panel.getBoundingClientRect().top - 12))}px`;
      };
      const show = key => {
        clearTimeout(hoverTimer);
        if (active === key) return;
        active = key;
        tabs.forEach(tab => tab.setAttribute('aria-expanded', String(tab.dataset.msTab === key)));
        panels.forEach(panel => {
          const opened = panel.dataset.msPanel === key;
          clearTimeout(hiding.get(panel));
          if (opened) {
            const wasHidden = panel.hidden;
            panel.hidden = false;
            fitPanel(panel);
            if (wasHidden) requestAnimationFrame(() => {
              if (active === panel.dataset.msPanel) panel.classList.add('ms-nav__panel--open');
            });
            else panel.classList.add('ms-nav__panel--open');
          } else panel.classList.remove('ms-nav__panel--open');
          if (opened) panel.scrollTop = 0;
          else hiding.set(panel, setTimeout(() => { panel.hidden = true; }, 190));
        });
        document.body.classList.toggle('ms-menu-is-open', Boolean(key));
      };
      const delayedClose = () => { clearTimeout(hoverTimer); hoverTimer = setTimeout(() => show(null), 180); };
      tabs.forEach(tab => {
        tab.addEventListener('click', () => show(active === tab.dataset.msTab ? null : tab.dataset.msTab));
        tab.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { clearTimeout(hoverTimer); hoverTimer = setTimeout(() => show(tab.dataset.msTab), 100); } });
        tab.addEventListener('focus', () => show(tab.dataset.msTab));
      });
      desktop.addEventListener('pointerleave', delayedClose);
      window.addEventListener('resize', () => panels.forEach(panel => {
        if (!panel.hidden) fitPanel(panel);
      }));
      desktop.addEventListener('shopify:block:select', event => {
        const selected = tabs.find(tab => tab.dataset.msBlockId === event.detail?.blockId);
        if (selected) show(selected.dataset.msTab);
      });
      panels.forEach(panel => {
        panel.addEventListener('pointerenter', () => clearTimeout(hoverTimer));
        panel.addEventListener('pointerleave', delayedClose);
      });
      document.addEventListener('click', event => { if (!desktop.contains(event.target)) show(null); });
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && active) { const previous = active; show(null); tabs.find(tab => tab.dataset.msTab === previous)?.focus(); } });
    });
    root.querySelectorAll('[data-ms-mobile]:not([data-ms-ready])').forEach(mobile => {
      mobile.dataset.msReady = 'true';
      const opener = mobile.querySelector('.ms-mobile__open');
      const drawer = mobile.querySelector('.ms-mobile__drawer');
      const backdrop = mobile.querySelector('.ms-mobile__backdrop');
      const back = mobile.querySelector('[data-ms-back]');
      const title = mobile.querySelector('[data-ms-title]');
      const scroll = mobile.querySelector('.ms-mobile__scroll');
      const screens = [...mobile.querySelectorAll('[data-ms-screen]')];
      let path = ['main'];
      let oldFocus;
      let oldOverflow;
      let closeTimer;
      const render = () => {
        const key = path[path.length - 1];
        const screen = screens.find(item => item.dataset.msScreen === key);
        screens.forEach(item => { item.hidden = item !== screen; });
        back.hidden = path.length === 1;
        title.textContent = key === 'main' ? (mobile.dataset.msHomeLabel || 'MIKE SPORT') : (screen?.dataset.msLabel || key.split('-')[0]).toUpperCase();
        scroll.scrollTop = 0;
      };
      const close = () => {
        if (drawer.hidden || drawer.dataset.closing === 'true') return;
        drawer.dataset.closing = 'true';
        drawer.classList.remove('ms-mobile__drawer--open');
        backdrop.classList.remove('ms-mobile__backdrop--open');
        opener.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = oldOverflow;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          drawer.hidden = true;
          backdrop.hidden = true;
          drawer.dataset.closing = 'false';
          path = ['main'];
          render();
        }, 270);
        oldFocus?.focus();
      };
      const open = () => {
        if (!drawer.hidden) {
          if (drawer.dataset.closing === 'true') {
            clearTimeout(closeTimer);
            drawer.dataset.closing = 'false';
            drawer.classList.add('ms-mobile__drawer--open');
            backdrop.classList.add('ms-mobile__backdrop--open');
            opener.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
          }
          return;
        }
        oldFocus = document.activeElement;
        oldOverflow = document.body.style.overflow;
        drawer.hidden = false;
        backdrop.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        path = ['main'];
        render();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            drawer.classList.add('ms-mobile__drawer--open');
            backdrop.classList.add('ms-mobile__backdrop--open');
          });
        });
        drawer.querySelector('.ms-mobile__close').focus();
      };
      opener.addEventListener('click', open);
      mobile.addEventListener('shopify:block:select', event => {
        const selected = [...mobile.querySelectorAll('[data-ms-block-id]')]
          .find(item => item.dataset.msBlockId === event.detail?.blockId);
        if (!selected) return;
        open();
        path = ['main', selected.dataset.msNext];
        render();
      });
      mobile.querySelectorAll('[data-ms-close]').forEach(button => button.addEventListener('click', close));
      back.addEventListener('click', () => { if (path.length > 1) { path.pop(); render(); back.focus(); } });
      mobile.addEventListener('click', event => {
        const next = event.target.closest('[data-ms-next]');
        if (next && screens.some(item => item.dataset.msScreen === next.dataset.msNext)) {
          path.push(next.dataset.msNext);
          render();
          scroll.querySelector('[data-ms-screen]:not([hidden]) .ms-mobile__all')?.focus();
        }
      });
      document.addEventListener('keydown', event => {
        if (drawer.hidden || drawer.dataset.closing === 'true') return;
        if (event.key === 'Escape') { close(); return; }
        if (event.key !== 'Tab') return;
        const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled])')].filter(item => item.getClientRects().length);
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      render();
    });
  }
  initMenus();
  document.addEventListener('shopify:section:load', event => initMenus(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('.ms-nav a[href="#"], .ms-mobile a[href="#"]');
    if (link) event.preventDefault();
  });
})();
